/**
 * Toggle the password input type. This allows the password to be previewed.
 */
export function togglePasswordVisibility() {
    const passwordInput = document.querySelector(".js-password-input") as HTMLInputElement;
    const eyeIcon = document.querySelector(".password-visibility");
    const currentType = passwordInput.type;

    if (currentType === "password") {
        passwordInput.type = "text";
        eyeIcon?.classList.remove("password-visibility--visible");
        eyeIcon?.classList.add("password-visibility--hidden");
    } else {
        passwordInput.type = "password";
        eyeIcon?.classList.remove("password-visibility--hidden");
        eyeIcon?.classList.add("password-visibility--visible");
    }
}
